import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	refinementInvalidOptionMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	refinementInvalidProjectOptionMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	refinementInvalidOptionMessageGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	refinementInvalidProjectOptionMessageGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	refinementInvalidOptionMessage: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-option-message',
		defaultMessage: 'Your project and {refinement} selection is invalid.',
		description:
			'The text displayed when you hover over an invalid selected option in the refinement bar dropdown',
	},
	refinementInvalidProjectOptionMessage: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-project-option-message',
		defaultMessage: 'Your project selection is invalid.',
		description:
			'The text displayed when you hover over an invalid selected project in the refinement bar dropdown',
	},
	refinementInvalidOptionMessageGalaxia: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-option-message-galaxia',
		defaultMessage: 'Your space and {refinement} selection is invalid.',
		description:
			'The text displayed when you hover over an invalid selected option in the refinement bar dropdown',
	},
	refinementInvalidProjectOptionMessageGalaxia: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-project-option-message-galaxia',
		defaultMessage: 'Your space selection is invalid.',
		description:
			'The text displayed when you hover over an invalid selected project in the refinement bar dropdown',
	},
});
export default messages;
